export default "__VITE_ASSET__BJe_ig$4__"